import React, { useState } from 'react';
import { FaPhone, FaEnvelope, FaBars, FaTimes } from 'react-icons/fa';
import 'bootstrap/dist/css/bootstrap.min.css';
import { BrowserRouter as Router, Routes, Route, Link } from 'react-router-dom';

import Home from './pages/home';
import About from './pages/about';
import Products from './pages/products';
import Contact from './pages/contact';
import './App.css';
import logo from './assets/logo-Z.png';

function App() {
  const [drawerOpen, setDrawerOpen] = useState(false);

  return (
    <Router>
      <div className="app-container">
        {/* Navbar */}
        <nav className="navbar">
          {/* Left - Logo */}
          <div className="nav-left">
            <img src={logo} alt="Logo" className="logo" />
          </div>

          {/* Center links - Desktop only */}
          <div className="nav-center desktop-only">
            <Link to="/" className="nav-link">Home</Link>
            <Link to="/about" className="nav-link">About</Link>
            <Link to="/products" className="nav-link">Products</Link>
            <Link to="/contact" className="nav-link">Contact</Link>
          </div>

          {/* Right info - Desktop only */}
          <div className="nav-right desktop-only">
            <span className="phone-icon">
              <FaPhone /> +91 7339416813
            </span>
            <span className="email-icon">
              <FaEnvelope /> tpabricks@gmail.com
            </span>
            <Link to="/contact">
              <button className="quote-button">Get a quote</button>
            </Link>
          </div>

          {/* Mobile hamburger icon */}
          <div className="mobile-only" onClick={() => setDrawerOpen(true)}>
            <FaBars size={22} style={{ cursor: 'pointer' }} />
          </div>
        </nav>

        {/* Drawer for mobile */}
        <div className={`drawer ${drawerOpen ? 'open' : ''}`}>
          <div className="drawer-header">
            <FaTimes className="close-icon" onClick={() => setDrawerOpen(false)} />
          </div>
          <div className="drawer-content">
            <Link to="/" onClick={() => setDrawerOpen(false)}>Home</Link>
            <Link to="/about" onClick={() => setDrawerOpen(false)}>About</Link>
            <Link to="/products" onClick={() => setDrawerOpen(false)}>Products</Link>
            <Link to="/contact" onClick={() => setDrawerOpen(false)}>Contact</Link>
            <hr />
            <p><FaPhone /> +91 7339416813</p>
            <p><FaEnvelope />  tpabricks@gmail.com</p>

            <Link to="/contact">
              <button className="quote-button">Get a quote</button></Link>
          </div>
        </div>
      </div>

      {/* Routes */}
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/about" element={<About />} />
        <Route path="/products" element={<Products />} />
        <Route path="/contact" element={<Contact />} />
      </Routes>

      {/* Footer */}
      { <footer className="footer">
        <p>© {new Date().getFullYear()} TPA. All rights reserved.</p>
      </footer> }

    </Router>
  );
}

export default App;
